import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=12b95d90&scoped=true&lang=html&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b95d90",
  null
  
)

export default component.exports